import React, { Component } from 'react';
import { connect } from 'react-redux'

import Centered from "../Components/Centered";
import CalloutSection from "../Components/CalloutSection";
import TitleText from "../Components/TitleText";
import Theme from "../Containers/Theme";
import PrimaryButton from "../Components/PrimaryButton";
import ParagraphText from "../Components/ParagraphText";
import Validator from "../Containers/Validator";
import TopContent from "../Components/TopContent";
import ThemeList from "../Helpers/ThemeList";
import Borders from "../Containers/Borders";
import GiftAmount from "../Components/GiftAmount";

class VerifyPage extends Component {
  render() {
    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <Validator/>
            <div className="spacer-40px" />
            <Centered>
              <TitleText>Verify details</TitleText>
              <div className="spacer-20px" />
              <ParagraphText>Recipient:&nbsp;
                <ParagraphText bold> {this.props.recipientEmail } </ParagraphText>
              </ParagraphText>
              <ParagraphText>Sender:&nbsp;
                <ParagraphText bold>{this.props.senderEmail } </ParagraphText>
              </ParagraphText>
              <ParagraphText>Amount:&nbsp;
                <ParagraphText bold>
                  <GiftAmount/>
                </ParagraphText>
              </ParagraphText>

              <div className="spacer-20px" />
              <ParagraphText>Note:&nbsp;</ParagraphText>
              <Borders>
                <ParagraphText bold className="note">{this.props.note}</ParagraphText>
              </Borders>

              <div className="spacer-20px" />
              <Theme
                single={true}
                theme={ThemeList.find(theme => theme.template === this.props.template)}
              />

              <div className="spacer-40px" />

              <PrimaryButton to="/payment" styles={'align-self: center;'}>Fund gift →</PrimaryButton>
              <div className="spacer-40px" />
            </Centered>
          </CalloutSection>
        </TopContent>
      </Centered>
    );
  }
}

const mapStateToProps = (state) => ({
  recipientEmail: state.gift.recipientEmail,
  senderEmail: state.gift.senderEmail,
  giftAmount: state.gift.giftAmount,
  template: state.gift.template,
  note: state.gift.note,
  wallet: state.wallet.wallet,
  rates: state.conversionRates.rates,
  ratesUpdated: state.conversionRates.ratesUpdated,
});

export default connect(mapStateToProps)(VerifyPage);



// WEBPACK FOOTER //
// ./src/Pages/VerifyPage.js